import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import { layoutClassNames } from '@/utils/consts';

import styles from './index.module.scss';

const AppLayout = () => {
  return (
    <div className={styles.viewBox}>
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        <main className={classNames(styles.main, layoutClassNames.mainContent)}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
